import React, {Component} from "react";
import {Link} from "react-router-dom";
import SportIcon from "../../../components/SportIcon";

class Sport extends Component {
	render() {
		const {sport} = this.props;

		return (
				<div className={`events__header`}>
					<div className="events__header__sportname">
						<span className="sport-icon small green events__header__sporticon">
							<SportIcon sportId={sport.id}/>
						</span>
						<span>&nbsp;<Link to={`/live-sport/${sport.id}`}>{sport.name}</Link></span>
					</div>
				</div>
		);
	}
}

export default Sport;


// WEBPACK FOOTER //
// ./src/app/pages/Live/modules/Sport.js